import BaseUseCase from "../../../base_use_case.js";

class ShowCompanyUseCase extends BaseUseCase {

  execute(identifier) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/admin/companies/companies/${identifier}`,
    });
  }
}

const instance = new ShowCompanyUseCase();
export default instance;